import React, { PureComponent } from 'react';
import T from 'prop-types';
import SplashScreen from '../splashScreen';

class UserDataGate extends PureComponent {
  componentDidMount() {
    this.props.getInfo();
  }

  render() {
    if (this.props.isStatusInitial) {
      return <SplashScreen />;
    }

    return this.props.children;
  }
}

UserDataGate.propTypes = {
  getInfo: T.func.isRequired,

  isStatusInitial: T.bool.isRequired,
  children: T.node.isRequired,
};

export default UserDataGate;
